import React, { Component } from 'react';
import Cookies from 'js-cookie'
import Modal from "react-modal";

class OptInPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            optInModalOpen: false,
            showModal: false,
            showThankYou: false,
            cookieValue: Cookies.get('OPTIN')
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    componentDidMount() {

        let cookieValue = this.state.cookieValue;

        //Wait 5 seconds before anything happens
        //This was a UX requirement
        this.sleep(5000).then(r => {

            if(cookieValue === undefined) {
                this.setState( {optInModalOpen: true });
                this.setState({showModal: true });

            } else {
                this.setState( {optInModalOpen: false });
                this.setState({showModal: false});

            }
        });

    }

    handleCookieClick(e) {
        e.preventDefault();

        //Set a cookie to expire a year from now
        Cookies.set('OPTIN', 'true', {expires: 365, secure: true, sameSite: 'strict'});

    }

    handleCloseClick(e) {

        //Set a session cookie that will reappear on next session
        Cookies.set('OPTIN', 'true', {secure: true, sameSite: 'strict'});
        this.setState({ showModal: false });
        this.setState({ optInModalOpen: false });

    }

    handleNotNowClick(e) {
        e.preventDefault();

        //Set a cookie to expire 14 days from now
        Cookies.set('OPTIN', 'true', {expires: 14, secure: true, sameSite: 'strict'});
        this.setState({ showModal: false });
        this.setState({ optInModalOpen: false });

        // window.location.reload(false);
    }

    onSubmit(e) {
        e.preventDefault();
        let formData = {
            firstName : e.target.firstName.value,
            zipPostal : e.target.zipPostal.value,
            emailAddress : e.target.emailAddress.value,
            elqFormName : e.target.elqFormName.value,
            elqSiteId : e.target.elqSiteId.value,
            elqCampaignId : e.target.elqCampaignId.value
        };
        this.handleCookieClick(e);
        let response = this.eloquaSubmit(formData);
        // this.state.showThankYou = true;
        this.setState({showThankYou: true});
        this.setState({showModal: true});
    }

    encodeFormData = (data) => {
        return Object.keys(data)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
            .join('&');
    }

    eloquaSubmit(formData){

        return fetch(
            `https://s351095147.t.eloqua.com/e/f2`,
            {
                method: 'POST',
                mode: 'no-cors',
                body: this.encodeFormData(formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then(function(response) {
            return response;
        });


    }

    render() {
         let showSuccess = !this.state.showThankYou;

         return (
             <Modal
                 isOpen={ this.state.optInModalOpen }
                 onRequestClose={ () => this.closeOptInModal() }
                 contentLabel="Modal"
                 overlayClassName={"ReactModal__OptIn"}
                 shouldCloseOnOverlayClick={false}>
                 <button
                     className="ReactModal__close hatch-modal-close"
                     onClick={ () => this.handleCloseClick() }>
                     <span className="fa fa-times" aria-hidden="true" />
                     <span className="assistive-text">close</span>
                 </button>
                 <div className="ankle pb-4 pt-5 px-2 p-md-5">
                     {showSuccess &&
                     <div className="row p-0">
                         <h2 className="col h1 modal-title pt-lg-3 pr-0">Subscribe & <span
                             className="text-red">get 10% off </span>your next purchase on the SentrySafe Store.</h2>
                         <div className="col eloquaForm">
                             <form onSubmit={e => this.onSubmit(e)}>
                                 <input value="copyOfSentrySafeOptInAnkle-1639583006950" type="hidden" name="elqFormName"/>
                                 <input value="351095147" type="hidden" name="elqSiteId"/>
                                 <input name="elqCampaignId" type="hidden" value="ss"/>
                                 <div className="form-group mb-3 row">
                                     <div className="col md-6 mb-3 mb-lg-1">
                                         <input type="text" name="firstName" id="fe1366" required="true"
                                                placeholder="FIRST NAME"/>
                                     </div>
                                     <div className="col xs-9 md-4 mb-lg-1">
                                         <input type="text" name="zipPostal" maxLength="5" pattern="[0-9]*" id="fe1367"
                                                required="true" placeholder="ZIP CODE"/>
                                     </div>
                                 </div>
                                 <div className="form-group row">
                                     <div className="col md-10">
                                         <input type="email" name="emailAddress" id="fe1368" required="true"
                                                placeholder="YOU@EMAIL.COM"/>
                                     </div>
                                 </div>
                                 <button type="submit" className="btn btn-primary mt-1" id="fe1369">Subscribe</button>
                                 <a href="#" className="opt-out mt-3 mt-md-0 ml-3 small text-underline"
                                    onClick={e => this.handleNotNowClick(e)}>Not now, maybe later</a>
                                 <p className="small pt-2">*Only customers in the U.S. will receive these emails from SentrySafe. Discount applies to items shipped within the contiguous United States only.</p>
                             </form>
                         </div>
                     </div>
                     }
                     {!showSuccess &&
                     <div>
                         <h2 className="h1 modal-title pt-lg-3">Thank you for signing up!</h2>
                         <p>Please check your email for your exclusive discount code.</p>
                     </div>
                     }
                 </div>
             </Modal>
        );

    };
}

export default OptInPopup;


// WEBPACK FOOTER //
// ./src/pages/components/OptInPopup.js